import { HorizontalDivider, Image, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getSafeInnerHtml, isHtmlEmpty } from '@hero/utils';

import * as S from './style';

function CollectionDescription({ aboutMessage }) {
  const { t } = useTranslation();

  return (
    <S.CollectionDescription>
      <Image name="experienceGiftBoxTitleImage" width="100%" />
      <HorizontalDivider $margin="16px 0" />
      <S.GiftCollection name="experienceCollectionImage" />
      <S.Description>
        {isHtmlEmpty(aboutMessage) ? (
          <S.DescriptionPlaceHolder variant="caption2SemiBold" color="fg">
            ({t('yourCollectionDescriptionHere')})
          </S.DescriptionPlaceHolder>
        ) : (
          <>
            <Typography variant="caption2Bold">{t('aboutThisGiftCollection')}:</Typography>
            <S.DescriptionText variant="caption2" color="fg" {...getSafeInnerHtml(aboutMessage)} />
          </>
        )}
      </S.Description>
    </S.CollectionDescription>
  );
}

CollectionDescription.propTypes = {
  aboutMessage: PropTypes.string
};

export { CollectionDescription };
